import {
  PostHogProvider as Provider,
  useFeatureFlagVariantKey as useFeatureFlag,
  usePostHog,
} from 'posthog-js/react';

const options = {
  api_host: import.meta.env.VITE_POSTHOG_API_HOST as undefined | string,
  ui_host: import.meta.env.VITE_POSTHOG_UI_HOST as undefined | string,
  defaults: '2025-05-24',
} as const;

// only in place for the POC, will be removed later
// this helps skipping code in case the API key is not set and therefore posthog not available
export const PostHogProvider = ({children}: React.PropsWithChildren) => {
  if (!import.meta.env.VITE_POSTHOG_API_KEY) {
    return <>{children}</>;
  }

  return (
    <Provider apiKey={import.meta.env.VITE_POSTHOG_API_KEY} options={options}>
      {children}
    </Provider>
  );
};

// only in place for the POC, will be removed later
// this helps skipping code in case the API key is not set and therefore posthog not available
export const useFeatureFlagVariantKey = import.meta.env.VITE_POSTHOG_API_KEY
  ? // eslint-disable-next-line sonarjs/function-return-type
    (name: string) => {
      // @ts-expect-error this is in place to enable flag overriding when we implement and replace split-io we can hopefully use the posthog toolbar
      window.posthog = usePostHog();
      return useFeatureFlag(name);
    }
  : () => {
      return undefined;
    };
